<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
          <graph-tool-bar :showSource="false" granularity="day" @on-selected="onPanelSelect"></graph-tool-bar>
        </md-card-header>

        <md-card-content>
          <highcharts class="charts" :options="chartOptions" ref="chart"></highcharts>
          <br />
          <div class="modal-footer">
            <md-button
              v-show="interval === 0"
              class="md-success"
              @click.native="buttonSelect"
            >Refresh</md-button>
            <md-button v-show="interval > 0" disabled>Refresh ({{interval}})</md-button>
          </div>
        </md-card-content>
      </md-card>
    </div>

    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>


<script>
import graphToolBar from "@/components/GraphToolBar";
import areaChartOptions from "@/config/charts/area";
import axios from "axios";
import { getSelectedDeviceToken } from "@/storage/memoryStorage";
import snackBar from "@/components/SnackBar";

export default {
  components: {
    "graph-tool-bar": graphToolBar,
    "snack-bar": snackBar
  },

  data() {
    return {
      chartOptions: null,
      permissions: 2,
      selected: {},
      interval: 0,
      intervalTimer: null,
      source: null
    };
  },

  computed: {
    getLegend() {
      return this.$store.getters.getAPCharts;
    }
  },

  created() {
    this.chartOptions = {
      chart: {
        polar: false,
        zoomType: null
      },
      title: {
        text: ""
      },
      subtitle: {
        text: ""
      },
      xAxis: {
        allowDecimals: false,
        labels: {
          style: {
            fontSize: "12px"
          },
          formatter:function(){
                return (this.value + 1);
            }
        },
        scrollbar: {
          enabled: false
        }
      },
      yAxis: {
        min: 0,
        max: 100,
        title: {
          text: ""
        },
        labels: {
          format: "{value}",
          style: {
            fontSize: "12px"
          }
        },
        type: "linear"
      },
      series: [],
      tooltip: {
        style: {
          whiteSpace: "nowrap",
          fontSize: "14px"
        },
        pointFormat:
          "<span style='color:{point.color}'>●</span> {series.name}: <b>{point.y:.3f}</b><br/>",
        headerFormat: ""
      },
      exporting: {
        enabled: true,
        buttons: {
          contextButton: {
            menuItems: [
              "viewFullscreen",
              "printChart",
              "separator",
              "downloadCSV",
              "downloadXLS",
              "downloadPNG",
              "downloadPDF",
              "viewData"
            ]
          }
        }
      },
      credits: {
        enabled: false
      },
      colors: [       
        "#f44336",
        "#ff9800",
        "#4caf50",
        "#fb4579",
        "#4b63ec",
        "#9761c8",
        "#00bcd4",
        "#fb636a",
        "#206692",
        "#668891"
      ],
      legend: {
        enabled: false,
        verticalAlign: "top"
      },
      lang: {
        decimalPoint: "."
      },
      navigator: {
        enabled: false
      },
      scrollbar: {
        enabled: true,
        liveRedraw: true,
        showFull: false
      },
      plotOptions: {
        pointStart: 1,
        series: {
          animation: false
        }
      }
    };

    this.chartOptions.title.text = "Harmonics chart";
    this.chartOptions.yAxis.labels.format = "{value} %";
    this.chartOptions.tooltip.pointFormat =
      "<span style='color:{point.color}'>●</span> {series.name}: <b>{point.y:.3f} %</b><br/>";
    this.chartOptions.series = [];

    this.chartOptions.chart.events = {
      redraw: function(event) {
        this.hideLoading();
      }
    };

    this.setChartSeries();
  },

  mounted() {
    const { chart } = this.$refs.chart;
    chart.showLoading();

    let chartPermissionsList = {};

    if (this.permissions >= 1) {
      chartPermissionsList.legend = {
        enabled: true
      };
    }

    if (this.permissions >= 2) {
      chartPermissionsList.chart = {
        zoomType: "x"
      };
    }

    chart.update(chartPermissionsList);
  },

  methods: {
    setChartSeries() {
      const onLegendSelect = (phase, visibility) => {
        let copyLegendStore = this.getLegend;
        copyLegendStore[phase] = !visibility;
        this.$store.commit("setAPSelectedChartLegend", copyLegendStore);
      };

      const legends = [
        {
          name: "L1 voltage",
          key: "L1_U"
        },
        {
          name: "L1 current",
          key: "L1_I"
        },
        {
          name: "L2 voltage",
          key: "L2_U"
        },
        {
          name: "L2 current",
          key: "L2_I"
        },
        {
          name: "L3 voltage",
          key: "L3_U"
        },
        {
          name: "L3 current",
          key: "L3_I"
        }
      ];

      this.chartOptions.series = [];

      legends.forEach(legend => {
        this.chartOptions.series.push({
          name: legend.name,
          type: "column",
          marker: {
            enabled: false
          },
          visible: this.getLegend[legend.key],
          dashStyle: "Solid",
          data: [],
          events: {
            legendItemClick: function(event) {
              onLegendSelect(legend.key, event.target.visible);
            }.bind(this)
          }
        });
      });
    },

    buttonSelect() {
      if (this.interval == 0) {
        this.getAPIData();
        this.interval = 60;

        this.intervalTimer = setInterval(() => {
          if (this.interval == 0) {
            clearInterval(this.intervalTimer);
          } else {
            this.interval--;
          }
        }, 1000);
      } else {
      }
    },

    onPanelSelect(data) {
      this.selected = data;
      this.$nextTick(() => {
        this.buttonSelect();
      });
    },

    getAPIData() {
      const chartRef = this.$refs.chart.chart;
      chartRef.showLoading();

      this.source = axios.CancelToken.source();


//  let seris= {

//  U: {

//    L1: {

//      values: [

//        230.137,

//        4.69211,

//        0.780353,

//        3.94054,

//        2.06882,

//        2.74274,

//        2.38077,

//        0.611411,

//        1.9945,

//        0.283976,

//        0.876986,

//        0.014723,

//        0.993266,

//        1.05953,

//        0.783343,

//        0.680145,

//        0.70216,

//        0.178622,

//        0.909971,

//        0.421848,

//        0.817948,

//        0.456739,

//        0.0774114,

//        0.389105,

//        0.195066,

//        0.150952,

//        0.302418,

//        0.103566,

//        0.140481,

//        0.461608,

//        0.366014,

//        0.238798,

//        0.42154,

//        0.424923,

//        0.360023,

//        0.539375,

//        0.0561274,

//        0.46287,

//        0.288665,

//        0.150137,

//        0.46677,

//        0.173887,

//        0.157164,

//        0.281304,

//        0.443252,

//        0.289762,

//        0.0237817,

//        0.217331,

//        0.129354,

//        0.320796,

//        0.340123,

//        0.27978,

//        0.0450586,

//        0.130868,

//        0.354137,

//        0.148848,

//        0.0572264,

//        0.289456,

//        0.141184,

//        0.162141

//      ],

//      phases: [

//        0,

//        0.852031,

//        2.80601,

//        2.62319,

//        1.3777,

//        2.54426,

//        0.694704,

//        2.83948,

//        1.90201,

//        1.73649,

//        2.57572,

//        1.30147,

//        1.58628,

//        0.307,

//        0.892947,

//        1.98309,

//        0.0904738,

//        0.0352233,

//        2.32579,

//        0,

//        0,

//        0,

//        0,

//        0,

//        0,

//        0,

//        0,

//        0,

//        0,

//        0,

//        0,

//        0,

//        0,

//        0,

//        0,

//        0,

//        0,

//        0,

//        0,

//        0,

//        0,

//        0,

//        0,

//        0,

//        0,

//        0,

//        0,

//        0,

//        0,

//        0,

//        0,

//        0,

//        0,

//        0,

//        0,

//        0,

//        0,

//        0,

//        0,

//        0

//      ]

//    },

//    L2: {

//      values: [

//        229.951,

//        9.70407,

//        1.62269,

//        5.049,

//        0.651918,

//        3.33894,

//        1.67307,

//        2.00759,

//        1.8009,

//        0.732695,

//        0.902879,

//        0.707522,

//        1.47241,

//        0.95297,

//        0.544376,

//        0.421163,

//        0.490836,

//        0.963826,

//        0.63937,

//        0.251876,

//        0.724228,

//        0.417251,

//        0.113383,

//        0.396264,

//        0.244738,

//        0.356138,

//        0.648277,

//        0.364954,

//        0.28774,

//        0.590326,

//        0.624962,

//        0.394884,

//        0.219532,

//        0.444694,

//        0.538434,

//        0.449422,

//        0.292253,

//        0.284609,

//        0.410617,

//        0.135064,

//        0.195733,

//        0.339072,

//        0.450033,

//        0.0315055,

//        0.108542,

//        0.267897,

//        0.0481009,

//        0.369351,

//        0.0035815,

//        0.270683,

//        0.302813,

//        0.055992,

//        0.127374,

//        0.131292,

//        0.315164,

//        0.192326,

//        0.104289,

//        0.344615,

//        0.310729,

//        0.32398

//      ],

//      phases: [

//        0,

//        120.414,

//        1.5036,

//        240.66,

//        120.841,

//        2.78558,

//        240.966,

//        123.288,

//        3.15466,

//        242.511,

//        122.292,

//        2.06348,

//        243.333,

//        122.831,

//        0.905518,

//        241.183,

//        122.928,

//        2.54199,

//        241.499,

//        120.407,

//        0.427002,

//        240.447,

//        120.468,

//        0.488037,

//        240.508,

//        120.529,

//        0.549072,

//        240.569,

//        120.59,

//        0.609863,

//        240.63,

//        120.651,

//        0.670898,

//        240.691,

//        120.711,

//        0.731934,

//        240.752,

//        120.772,

//        0.792969,

//        240.813,

//        120.833,

//        0.854004,

//        240.875,

//        120.895,

//        0.915039,

//        240.935,

//        120.956,

//        0.976074,

//        240.996,

//        121.017,

//        1.03711,

//        241.057,

//        121.078,

//        1.09814,

//        241.118,

//        121.139,

//        1.15918,

//        241.179,

//        121.2,

//        1.21973

//      ]

//    },

//    L3: {

//      values: [

//        230.021,

//        5.53605,

//        3.8696,

//        0.968395,

//        1.04102,

//        1.02759,

//        2.02172,

//        1.1329,

//        1.42733,

//        1.64559,

//        1.26585,

//        1.297,

//        0.53227,

//        0.0934386,

//        0.703119,

//        1.14613,

//        0.314476,

//        0.278152,

//        0.253054,

//        0.505264,

//        0.878407,

//        0.394011,

//        0.0745629,

//        0.146142,

//        0.272974,

//        0.127178,

//        0.319837,

//        0.396731,

//        0.175951,

//        0.473854,

//        0.0887335,

//        0.573369,

//        0.0202199,

//        0.329954,

//        0.354708,

//        0.0580882,

//        0.0491639,

//        0.147011,

//        0.401772,

//        0.216274,

//        0.126915,

//        0.452764,

//        0.102856,

//        0.0413332,

//        0.253846,

//        0.248332,

//        0.405983,

//        0.349962,

//        0.258723,

//        0.046416,

//        0.290268,

//        0.342801,

//        0.11105,

//        0.0955245,

//        0.181654,

//        0.00858056,

//        0.205953,

//        0.051481,

//        0.276074,

//        0.121605

//      ],

//      phases: [

//        0,

//        240.727,

//        0.763672,

//        123.071,

//        242.021,

//        0.93396,

//        122.116,

//        242.796,

//        1.97583,

//        123.22,

//        240.25,

//        0.329102,

//        122.693,

//        240.65,

//        1.87183,

//        120.404,

//        242.041,

//        0.925781,

//        123.149,

//        240.158,

//        0.166016,

//        120.174,

//        240.182,

//        0.189453,

//        120.198,

//        240.206,

//        0.213379,

//        120.221,

//        240.229,

//        0.237305,

//        120.245,

//        240.253,

//        0.260742,

//        120.269,

//        240.276,

//        0.28418,

//        120.292,

//        240.301,

//        0.308594,

//        120.316,

//        240.324,

//        0.332031,

//        120.34,

//        240.348,

//        0.355469,

//        120.363,

//        240.371,

//        0.378906,

//        120.388,

//        240.396,

//        0.40332,

//        120.411,

//        240.419,

//        0.426758,

//        120.435,

//        240.442,

//        0.450195,

//        120.458,

//        240.467,

//        0.474609

//      ]

//    }

//  },

//  I: {

//    L1: {

//      values: [

//        7.99896,

//        0.145736,

//        0.0315981,

//        0.0755152,

//        0.104559,

//        0.0974424,

//        0.0717034,

//        0.0561324,

//        0.0467317,

//        0.0481939,

//        0.0473371,

//        0.0151245,

//        0.0232496,

//        0.00407161,

//        0.0404779,

//        0.00787372,

//        0.0245655,

//        0.0120046,

//        0.001134,

//        0.0115199,

//        0.0249126,

//        0.00648479,

//        0.0206204,

//        0.0229193,

//        0.0248852,

//        0.00902514,

//        0.0058416,

//        0.00808591,

//        0.011437,

//        0.0208797,

//        0.0224328,

//        0.00630826,

//        0.00372371,

//        0.00961531,

//        0.014923,

//        0.0167316,

//        0.017217,

//        0.0132551,

//        0.0147939,

//        0.0143302,

//        0.00276032,

//        0.0130192,

//        0.011538,

//        0.0120193,

//        0.00144476,

//        0.00603413,

//        0.0145473,

//        0.00632563,

//        0.00408578,

//        0.00521435,

//        0.0063771,

//        0.00523134,

//        0.00315413,

//        0.00284174,

//        0.00374821,

//        0.0119465,

//        0.00726936,

//        0.00727095,

//        0.00216744,

//        0.00714407

//      ],

//      phases: [

//        0,

//        241.739,

//        181.938,

//        120.973,

//        60.9868,

//        1.15918,

//        301.774,

//        241.918,

//        181.56,

//        123.847,

//        61.3615,

//        1.89636,

//        302.977,

//        244.071,

//        183.128,

//        121.695,

//        62.5462,

//        3.83911,

//        303.15,

//        241.641,

//        181.723,

//        121.805,

//        61.8873,

//        1.96936,

//        302.051,

//        242.134,

//        182.216,

//        122.298,

//        62.3796,

//        2.46179,

//        302.544,

//        242.626,

//        182.708,

//        122.79,

//        62.8721,

//        2.9541,

//        303.036,

//        243.118,

//        183.2,

//        123.282,

//        63.3643,

//        3.44653,

//        303.529,

//        243.611,

//        183.693,

//        123.775,

//        63.8567,

//        3.93872,

//        304.021,

//        244.103,

//        184.185,

//        124.267,

//        64.3491,

//        4.43115,

//        304.513,

//        244.595,

//        184.677,

//        124.759,

//        64.8413,

//        4.92358

//      ]

//    },

//    L2: {

//      values: [

//        8.02288,

//        0.17379,

//        0.0361986,

//        0.13043,

//        0.100941,

//        0.115441,

//        0.04306,

//        0.0305137,

//        0.0198544,

//        0.0357642,

//        0.0121288,

//        0.0309747,

//        0.0347273,

//        0.0113863,

//        0.0253616,

//        0.00361632,

//        0.00475816,

//        0.0354676,

//        0.0146405,

//        0.0314732,

//        0.0193094,

//        0.00972386,

//        0.0208287,

//        0.0282077,

//        0.00585884,

//        0.0239653,

//        0.00704393,

//        0.0113175,

//        0.0188068,

//        0.00451209,

//        0.00526462,

//        0.0207856,

//        0.0161379,

//        0.00642606,

//        0.0184771,

//        0.0163395,

//        0.018235,

//        0.000554282,

//        0.00622307,

//        0.0165165,

//        0.00323293,

//        0.0157847,

//        0.0125603,

//        0.000775871,

//        0.00610003,

//        0.00915837,

//        0.00633694,

//        0.00986385,

//        0.0110464,

//        0.0108321,

//        0.00960794,

//        0.0121081,

//        0.00297103,

//        0.00128097,

//        0.00706453,

//        0.00748119,

//        0.00315484,

//        0.00563934,

//        0.00793408,

//        0.0065437

//      ],

//      phases: [

//        0,

//        0.192444,

//        182.573,

//        1.87659,

//        181.886,

//        2.48792,

//        182.118,

//        1.24805,

//        182.459,

//        2.67908,

//        180.473,

//        0.422119,

//        180.821,

//        2.40332,

//        179.827,

//        1.44629,

//        181.757,

//        1.35596,

//        182.54,

//        359.374,

//        179.343,

//        359.312,

//        179.28,

//        359.249,

//        179.218,

//        359.187,

//        179.155,

//        359.124,

//        179.092,

//        359.061,

//        179.03,

//        358.999,

//        178.967,

//        358.936,

//        178.905,

//        358.874,

//        178.842,

//        358.811,

//        178.779,

//        358.748,

//        178.717,

//        358.686,

//        178.654,

//        358.623,

//        178.592,

//        358.561,

//        178.529,

//        358.498,

//        178.467,

//        358.436,

//        178.404,

//        358.373,

//        178.342,

//        358.31,

//        178.278,

//        358.247,

//        178.216,

//        358.185,

//        178.153,

//        358.122

//      ]

//    },

//    L3: {

//      values: [

//        7.99746,

//        0.190366,

//        0.0868267,

//        0.0388863,

//        0.0666572,

//        0.0534769,

//        0.0563714,

//        0.0267019,

//        0.066434,

//        0.0466446,

//        0.00979594,

//        0.00032989,

//        0.0038834,

//        0.0341135,

//        0.0149463,

//        0.0166816,

//        0.0115911,

//        0.011683,

//        0.0337742,

//        0.0263952,

//        0.014455,

//        0.0192229,

//        0.00159767,

//        0.00309421,

//        0.00113056,

//        0.0138198,

//        0.0175903,

//        0.0181593,

//        0.0119958,

//        0.00495149,

//        0.0086863,

//        0.00527114,

//        0.00798597,

//        0.0130007,

//        0.00373104,

//        0.0161506,

//        0.0119149,

//        0.000730291,

//        0.00092688,

//        0.00268544,

//        0.0052548,

//        0.0120466,

//        0.00996809,

//        0.00438366,

//        0.0102597,

//        0.00821995,

//        0.0139173,

//        0.00415088,

//        0.00412321,

//        0.0056365,

//        0.00203076,

//        0.00874351,

//        0.0129041,

//        0.00601815,

//        0.00994884,

//        0.0118279,

//        0.0113029,

//        0.000319173,

//        0.00484969,

//        0.0038453

//      ],

//      phases: [

//        0,

//        122.067,

//        180.713,

//        240.55,

//        299.881,

//        2.10889,

//        61.822,

//        122.378,

//        182.667,

//        242.565,

//        301.943,

//        0.534668,

//        61.2329,

//        121.261,

//        180.417,

//        242.287,

//        301.121,

//        0.52832,

//        60.1738,

//        119.506,

//        179.481,

//        239.457,

//        299.432,

//        359.407,

//        59.3828,

//        119.358,

//        179.333,

//        239.309,

//        299.284,

//        359.26,

//        59.2344,

//        119.21,

//        179.186,

//        239.16,

//        299.136,

//        359.111,

//        59.0869,

//        119.062,

//        179.037,

//        239.013,

//        298.987,

//        358.963,

//        58.9385,

//        118.914,

//        178.889,

//        238.864,

//        298.84,

//        358.814,

//        58.79,

//        118.766,

//        178.741,

//        238.716,

//        298.691,

//        358.667,

//        58.6426,

//        118.617,

//        178.592,

//        238.568,

//        298.543,

//        358.52

//      ]

//    }

//  }

// };

//           chartRef.series[0].setData(seris.U.L1.values);
//           chartRef.series[1].setData(seris.I.L1.values);
//           chartRef.series[2].setData(seris.U.L2.values);
//           chartRef.series[3].setData(seris.I.L2.values);
//           chartRef.series[4].setData(seris.U.L3.values);
//           chartRef.series[5].setData(seris.I.L3.values);

      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_R + "/applied-precision/harmonics",
        data: {
          device_token: getSelectedDeviceToken(this.selected.device.mac)
        },
        cancelToken: this.source.token
      })
        .then(response => {

          chartRef.series[0].setData(response.data.data.U.L1.values);
          chartRef.series[1].setData(response.data.data.I.L1.values);
          chartRef.series[2].setData(response.data.data.U.L2.values);
          chartRef.series[3].setData(response.data.data.I.L2.values);
          chartRef.series[4].setData(response.data.data.U.L3.values);
          chartRef.series[5].setData(response.data.data.I.L3.values);

          chartRef.xAxis[0].setExtremes(null, null, true);
        })
        .catch(error => {
          chartRef.hideLoading();
          if (error.response) {
            if (error.response.data.code == 604) {
              this.$refs.snackbar.notify(
                this.$lang.messages.device_not_responding_or_offline
              );
            } else {
              this.$refs.snackbar.notify(
                this.$lang.messages.api_communication_error
              );
            }
          }
        });
    }
  },

  beforeDestroy() {
    this.source.cancel();
  }
};
</script>

<style lang="scss" scoped>
.md-layout {
  margin-top: -29px;
}
</style>